import React from "react";
import { TbGalaxy } from "react-icons/tb";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../Footer";

const SuccessfulHelp = () => {
    const { email } = useParams();
    const navigate = useNavigate()

    const backToHome = () => {
        navigate("/")
    }
    

    return (
        <div className="prereg_main">
            <div className="main_navbar">
                <div className="navbar">
                    <div className="nav_cont_1">
                        <a href="/">
                            <p id="title_navbar">
                                <i><TbGalaxy /></i>
                                Erioon
                            </p>
                        </a>
                    </div>
                    <div className="nav_cont_1"></div>
                </div>
            </div>
            <div className="prereg_cont_inner">
                <div className="register_conts_reg">
                    <div className="reg_cont_success">
                        <p className="call_action_title">Your help request has been successfully submitted <i className="fa-solid fa-check"></i></p>
                     
                        <p className="call_action_subtitle">You should receive a confirmation email shortly!</p>
                        <button className="call_action_subtitle_back_homepage" onClick={backToHome}><i className="fa-solid fa-arrow-left"></i> Back to homepage</button>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default SuccessfulHelp